import React from 'react';
import { Footer } from '../../../common/footer/footer';
import 'aos/dist/aos.css';
import Sidebar from "../sidebar/sidebar.js";

export const RoleFormJsx = (props) => {
  const {
    categoryData,
    handleChange,
    handleSubmit,
    roleName,
    handleRoleNameChange,
    handleBackToList,
    isEditMode
  } = props;

  return (
    <>
      <section className="entiredashboard admindashboard py-5 bg-light">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3 col-sm-12 mb-4">
              <div className="dashboardleftpanel p-3 bg-white shadow rounded">
                <Sidebar />
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-9 col-sm-12">
              <div className="dashboardrightpanel p-4 bg-white shadow rounded">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h2 className="text-primary mb-0">
                    {isEditMode ? 'Edit Role' : 'Add New Role'}
                  </h2>
                  <button
                    onClick={handleBackToList}
                    className="btn btn-outline-secondary"
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Back to List
                  </button>
                </div>

                <div className="expertsection">
                  {/* Role Name Input */}
                  <div className="mb-4">
                    <label htmlFor="roleName" className="form-label">
                      <strong>Role Name *</strong>
                    </label>
                    <input
                      type="text"
                      id="roleName"
                      className="form-control"
                      placeholder="Enter role name"
                      value={roleName}
                      onChange={handleRoleNameChange}
                      required
                    />
                  </div>

                  {categoryData?.length > 0 ? (
                    <>
                      <div className="searchdetails">
                        <h5 className="mb-3 text-secondary">
                          <i className="fas fa-shield-alt me-2"></i>
                          Module Permissions
                        </h5>
                        
                        {categoryData.map((data, moduleIndex) => (
                          <div 
                            key={`module-${data.moduleId}`} 
                            className="mb-4 p-4 border rounded bg-light"
                          >
                            <h4 className="text-dark mb-3">
                              <i className="fas fa-cube me-2"></i>
                              {data?.moduleName}
                            </h4>

                            <div className="row">
                              {data?.modulePermissions?.map((role, roleIndex) => (
                                <div 
                                  key={`permission-${role.modulePermissionId}`} 
                                  className="col-md-6 col-lg-4 mb-3"
                                >
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`${role.name}-${role.modulePermissionId}`}
                                      name={role.name}
                                      value={role.modulePermissionId}
                                      checked={role.hasPermission}
                                      onChange={(e) =>
                                        handleChange({
                                          modulePermissionId: role.modulePermissionId,
                                          moduleId: data.moduleId,
                                          checked: e.target.checked,
                                        })
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`${role.name}-${role.modulePermissionId}`}
                                    >
                                      <strong>{role.name}</strong>
                                    </label>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="d-flex justify-content-end gap-2">
                        <button
                          onClick={handleBackToList}
                          className="btn btn-outline-secondary px-4 py-2"
                        >
                          Cancel
                        </button>
                        <button 
                          onClick={handleSubmit} 
                          className="btn btn-primary px-4 py-2"
                          disabled={!roleName.trim()}
                        >
                          <i className={`fas ${isEditMode ? 'fa-save' : 'fa-plus'} me-2`}></i>
                          {isEditMode ? 'Update Role' : 'Create Role'}
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-5">
                      <div className="mb-3">
                        <i className="fas fa-exclamation-triangle fa-3x text-warning"></i>
                      </div>
                      <h5 className="text-muted">No modules available</h5>
                      <p className="text-muted">Please contact administrator to set up modules first.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default RoleFormJsx;